import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { ToastContainer, toast, Slide } from 'react-toastify'
import { Close } from 'pcln-icons'
import EmailSignUpComponent from './EmailSignUpComponent'
import 'react-toastify/dist/ReactToastify.css'

const StyledToastContainer = styled(ToastContainer)`
  &.Toastify__toast-container {
    width: 100%;
    padding: 16px;
    position: fixed;
    bottom: ${props => (props.isMobile ? '0px' : '-16px')};
  }
  & .Toastify__toast {
    padding: 0px;
    font-family: 'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }
  & .Toastify__toast-body {
    margin: 0px;
    padding: 0px;
  }
  & .Toastify__toast-body > div {
    width: 100%;
  }
  & .Toastify__close-button > svg {
    margin: 12px;
  }
`

const CloseButton = styled(Close)`
  cursor: pointer;
  margin: 8px;
  position: absolute;
  right: 0px;
`

type EmailSignupToastProps = {
  sourceId: string
  isMobile?: boolean
}

export default function EmailSignUpToast({
  sourceId,
  isMobile = false
}: EmailSignupToastProps) {
  const hideEmailOptIn =
    typeof window !== 'undefined' &&
    JSON.parse(localStorage.getItem('hideEmailOptIn') || '{}')

  const [hideUntilRefresh, setHideUntilRefresh] = useState(false)
  const toastId = React.useRef() as React.MutableRefObject<
    string | number | undefined
  >

  const [isToastShown, setIsToastShown] = useState(false)

  const closeToast = () => {
    toast.dismiss(toastId.current)
  }
  const [showSetiVariant, setShowSetiVariant] = useState(true)

  useEffect(() => {
    const CustomCloseButton = () => (
      <CloseButton
        onClick={() => {
          setHideUntilRefresh(true)
          closeToast()
        }}
        size={24}
        title="close"
        color="background.text"
      />
    )
    const setiVariantHasContent = (res: boolean) => {
      setShowSetiVariant(res)
    }

    const toastEmailSignup = () => {
      toastId.current = toast(
        <EmailSignUpComponent
          closeToast={() => closeToast()}
          isToast
          sourceId={sourceId}
          setiVariantHasContent={setiVariantHasContent}
          isToastVisibile={isToastShown}
        />,
        {
          closeButton: CustomCloseButton
        }
      )
    }
    return isToastShown ? toastEmailSignup() : closeToast()
  }, [isToastShown, sourceId])

  useEffect(() => {
    const showAt = isMobile ? 40 : 10
    const handleScroll = () => {
      const scrollTop = window.scrollY
      const docHeight = document.body.offsetHeight
      const winHeight = window.innerHeight
      const scrollPercent = scrollTop / (docHeight - winHeight)
      const scrollPercentRounded = Math.round(scrollPercent * 100)
      if (scrollPercentRounded > showAt) {
        setIsToastShown(true)
      } else {
        setIsToastShown(false)
      }
    }

    if (!hideEmailOptIn?.isHidden && !hideUntilRefresh && showSetiVariant) {
      window.addEventListener('scroll', handleScroll, { passive: true })
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }
  }, [hideEmailOptIn?.isHidden, hideUntilRefresh, isMobile, showSetiVariant])

  return showSetiVariant && !hideEmailOptIn.isHidden ? (
    <>
      <StyledToastContainer
        position="bottom-center"
        autoClose={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss={false}
        draggable={false}
        limit={1}
        transition={Slide}
        isMobile={isMobile}
      />
    </>
  ) : (
    <> </>
  )
}
